import React, { useState } from 'react';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '', phone: '', email: '', subject: '', message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${BASE_URL}/api/save_enquiry/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                alert("Message Sent Successfully!");
                setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
            } else {
                console.error("Server Error:", data);
                alert("Failed to send message: " + (data.error || JSON.stringify(data)));
            }
        } catch (error) {
            console.error("Connection Error:", error);
            alert("Server connection error.");
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Banner Section */}
            <div className="relative h-[300px] w-full flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('/banner-image.jpg')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase tracking-wider text-center px-4">Contact Us</h1>
            </div>

            <div className="py-16 px-6 container mx-auto">
                <h1 className="text-4xl font-bold text-[#002b5b] mb-10 text-center">Contact RBM Chemicals</h1>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                    {/* Contact Info + Map */}
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-[#002b5b]">Get In Touch</h2>
                        <p><strong>Managing Director:</strong> Mahesh Yadav</p>
                        <p><strong>Phone:</strong> +91 9253412469 , +91 8905550315</p>
                        <p><strong>Email:</strong> info@rbmchemicals.com</p>
                        <p><strong>Email:</strong> rbmchemicalsandsolutionsllp@yahoo.com</p>
                        <p><strong>Email:</strong> rbmchemicalsandsolutionsllp@gmail.com</p>
                        <p><strong>Address:</strong> Plot No. G1-123A, RIICO Industrial Area Khushkhera, Bhiwadi, Khairthal Tijara, Rajasthan - 301707</p>

                        {/* Google Maps Embed */}
                        <div className="w-full h-64 mt-6">
                            <iframe
                                title="RBM Chemicals Location"
                                className="w-full h-full rounded-lg shadow-md border-0"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.745423851576!2d76.81527717460594!3d28.490861290647368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d3d5f306987c1%3A0x6b7746401062b8c5!2sRIICO%20Industrial%20Area%2C%20Khushkhera%2C%20Bhiwadi%2C%20Rajasthan%20301707!5e0!3m2!1sen!2sin!4v1720410000000!5m2!1sen!2sin"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="bg-white p-8 shadow-lg rounded-lg border border-gray-200">
                        <input name="name" placeholder="Name" onChange={handleChange} value={formData.name} className="w-full p-3 mb-4 border rounded" required />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input name="phone" placeholder="Phone" onChange={handleChange} value={formData.phone} className="w-full p-3 mb-4 border rounded" required />
                            <input name="email" type="email" placeholder="Email" onChange={handleChange} value={formData.email} className="w-full p-3 mb-4 border rounded" required />
                        </div>
                        <input name="subject" placeholder="Subject" onChange={handleChange} value={formData.subject} className="w-full p-3 mb-4 border rounded" required />
                        <textarea name="message" placeholder="Message" onChange={handleChange} value={formData.message} className="w-full p-3 mb-4 border rounded h-32" required />
                        <button type="submit" className="w-full bg-[#002b5b] text-white p-3 rounded font-bold hover:bg-blue-900 transition">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;